import React, { Component } from 'react';
import { CenterText } from "../../smart/cells";
import ModificationLabel from "../../bookings/modification_label";

export default ({ value }) => (
  <CenterText className='status-column'>
    <ModificationLabel value={value}/>
  </CenterText>
);
